import React from "react"

export function Button({ children, className="", ...props }) {
  return (
    <button
      className={`px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}